/* @flow */
import cx from 'classnames';
import { Container } from 'flux/utils';
import GroupStore from 'groups/stores/GroupStore';
import Groups from 'collections/Groups';
import Activities from 'collections/Activities';
import ActivityStore from 'payments/stores/ActivityStore';
import PrintAnnouncements from './PrintAnnouncements.jsx';
import PrintActivity from './PrintActivity.jsx';
import PrintSubscribers from './PrintSubscribers.jsx';
import React from 'react';
import Divider from 'components/Divider.jsx';

type State = {
  groups: Groups,
  activities: Activities,
}

class PrintSettingsView extends React.Component {
  state: State;

  static getStores() {
    return [GroupStore, ActivityStore];
  }

  static calculateState() {
    return {
      groups: GroupStore.getOwnedGroups(),
      activities: ActivityStore.getOwnedActivities(),
    };
  }

  render() {
    return (
      <div className={cx('PrintSettingsView', this.props.className)}>
        <PrintAnnouncements groups={this.state.groups} />
        <Divider />
        <PrintSubscribers groups={this.state.groups} />
        <Divider />
        <PrintActivity activities={this.state.activities} />
      </div>
    );
  }
}

export default Container.create(PrintSettingsView);



// WEBPACK FOOTER //
// ./src/settings/components/PrintSettingsView.jsx